import React, { useEffect, useRef, useState } from "react";
import styles from "./HeaderComp.module.scss";
import logo from "../assets/Images/CompanyLogo.svg";
import FirtsockLogo from "../assets/Images//MindoriginLogo.png";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import {
  Button,
  FormControl,
  IconButton,
  LinearProgress,
  Menu,
  MenuItem,
  Select,
} from "@mui/material";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import logouticon from "../assets/Images/logouticon.svg";
import { confirmAlert } from "react-confirm-alert";
import pangreen from "../../Components/assets/Images/panicongreen.svg";
import pangrey from "../../Components/assets/Images/panicongrey.svg";
import aadhargreen from "../../Components/assets/Images/aadharicongreen.svg";
import aadhargrey from "../../Components/assets/Images/aadharicongrey.svg";
import profilegreen from "../../Components/assets/Images/profileicongreen.svg";
import profilegrey from "../../Components/assets/Images/profileicongrey.svg";
import ipvgreen from "../../Components/assets/Images/ipvicongreen.svg";
import ipvgrey from "../../Components/assets/Images/ipvicongrey.svg";
import bankgreen from "../../Components/assets/Images/bankicongreen.svg";
import bankgrey from "../../Components/assets/Images/bankicongrey.svg";
import nomineegreen from "../../Components/assets/Images/nomineeicongreen.svg";
import nomineegrey from "../../Components/assets/Images/nomineeicongrey.svg";
import uploadgreen from "../../Components/assets/Images/uploadicongreen.svg";
import uploadgrey from "../../Components/assets/Images/uploadicongrey.svg";
import esigngreen from "../../Components/assets/Images/esignicongreen.svg";
import esigngrey from "../../Components/assets/Images/esignicongrey.svg";
import tradinggrey from "../../Components/assets/Images/tradingicongrey.svg";
import tradinggreeen from "../../Components/assets/Images/tradingicongreen.svg";
import tcgrey from "../../Components/assets/Images/tandcicongrey.svg";
import tcgreeen from "../../Components/assets/Images/tandcicongreen.svg";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useSelector } from "react-redux";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import keyboardicon from "../../Components/assets/Images/stepkeyboard.svg";
import aadharicongrey from "../assets/Images/aadharicongrey.svg";
import bankicongrey from "../assets/Images/bankicongrey.svg";
import nomineeicongrey from "../assets/Images/nomineeicongrey.svg";
import sigicon from "../assets/Images/sigicon.svg";
import stylus from "../assets/Images/stylus.svg";

const Stages = [
  {
    title: "PAN Validation",
    iconGreen: <img src={pangreen} />,
    iconGrey: <img src={pangrey} />,
  },
  {
    title: "Aadhar Validation",
    iconGreen: <img src={aadhargreen} />,
    iconGrey: <img src={aadhargrey} />,
  },
  {
    title: "About Yourself",
    iconGreen: <img src={profilegreen} />,
    iconGrey: <img src={profilegrey} />,
  },
  {
    title: "Trading Preference",
    iconGreen: <img src={tradinggreeen} />,
    iconGrey: <img src={tradinggrey} />,
  },
  {
    title: "Bank Account",
    iconGreen: <img src={bankgreen} />,
    iconGrey: <img src={bankgrey} />,
  },
  {
    title: "Terms & Condition",
    iconGreen: <img src={tcgreeen} />,
    iconGrey: <img src={tcgrey} />,
  },
  {
    title: "Nominee",
    iconGreen: <img src={nomineegreen} />,
    iconGrey: <img src={nomineegrey} />,
  },
  {
    title: "Document Upload",
    iconGreen: <img src={uploadgreen} />,
    iconGrey: <img src={uploadgrey} />,
  },

  {
    title: "Identity Verification",
    iconGreen: <img src={ipvgreen} />,
    iconGrey: <img src={ipvgrey} />,
  },

  {
    title: "Esign",
    iconGreen: <img src={esigngreen} />,
    iconGrey: <img src={esigngrey} />,
  },
];
const StageNew = [
  {
    title: "Identity Verification",
    iconGreen: <img src={stylus} />,
    iconGrey: <img src={aadhargrey} />,
  },

  {
    title: "Bank Details",
    iconGreen: <img src={stylus} />,
    iconGrey: <img src={bankgrey} />,
  },

  {
    title: "Nominee Details",
    iconGreen: <img src={stylus} />,
    iconGrey: <img src={nomineegrey} />,
  },

  {
    title: "Sign & Submit",
    iconGreen: <img src={stylus} />,
    iconGrey: (
      <img
        src={sigicon}
        style={{
          filter: "grayscale(0.95) invert(0.1) brightness(1)",
        }}
      />
    ),
  },
];

const MappingValues: any = {
  kra_or_aadhaar: "Identity Verification",
  // customer_details: "About Yourself",
  // pan: "Identity Verification",
  nominee: "Nominee Details",
  esign: "Sign & Submit",
  bank: "Bank Details",
};
const MappingValuesNew: any = {
  pan: "PAN Validation",
  kra_or_aadhaar: "Aadhar Validation",
  customer_details: "About Yourself",
  ipv: "Identity Verification",
  segment: "Trading Preference",
  t_and_c: "Terms & Condition",
  nominee: "Nominee",
  esign: "Esign",
  bank: "Bank Account",
  document_upload: "Document Upload",
};

const steps = {
  "1": ["/panverification", "/aadhaar", "/tradingPreference", "/yourprofile"],
  "2": ["/linkusingifsc", "/termsandconditions"],
  "3": ["/nominee", "/uploaddocuments", "/ipv"],
  "4": ["/esign"],
};

function HeaderComp() {
  const pathName = useSelector((state: any) => state.PATHNAME.pathname);
  const completedstages = useSelector(
    (state: any) => state.PATHNAME.completedstages,
  );
  const currentstage = useSelector((state: any) => state.PATHNAME.currentstage);
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElMobile, setAnchorElMobile] = useState<null | HTMLElement>(
    null,
  );
  const open = Boolean(anchorEl);
  const openMobile = Boolean(anchorElMobile);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const handleClickMobile = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorElMobile(event.currentTarget);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseMobile = () => {
    setAnchorElMobile(null);
  };

  const getKeyByValue = (obj: any, value: string) => {
    return Object.keys(obj).find((key) => obj[key] === value);
  };

  const getStepByRoute = (route: string) => {
    return Object.entries(steps).find(([_, routes]) =>
      routes.includes(`${route}`),
    )?.[0];
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpenMenu(false);
        handleCloseMobile();
      }
    };

    if (openMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenu]);

  const handleLogout = () => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            sessionStorage.clear();
            window.location.href = "/";
          },
        },
      ],
    });
  };

  const currentStep: any = getStepByRoute(
    pathName ? pathName : "panverification",
  );

  const panstage =
    currentstage === "pan"
      ? "In Progress"
      : completedstages?.includes("pan")
        ? "Completed"
        : "Pending";
  const bankstage =
    currentstage === "bank"
      ? "In Progress"
      : completedstages?.includes("bank")
        ? "Completed"
        : "Pending";
  const nomineestage =
    currentstage === "nominee"
      ? "In Progress"
      : completedstages?.includes("nominee")
        ? "Completed"
        : "Pending";
  const esignstage =
    currentstage === "esign"
      ? "In Progress"
      : completedstages?.includes("esign")
        ? "Completed"
        : "Pending";

  // console.log("currentStep", currentStep, "pathName", pathName);

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.leftContainer}>
        <img
          src={FirtsockLogo}
          style={{ zIndex: 100, cursor: "pointer" }}
          onClick={() => {}}
          className={styles.Logo}
        />
      </div>
      {pathName !== "/" &&
        pathName !== "/confirm_otp" &&
        pathName !== "/confirmemailotp" &&
        pathName !== "/yourdetails" &&
        pathName !== "/ekyc_aadhaar" &&
        pathName !== "/ekyc_esign" &&
        pathName !== "/completed" &&
        pathName !== "/account_aggregator" &&
        pathName !== "/congratulations" && (
          <div className={styles.stepDesktop}>
            <img
              src={
                currentStep === "1"
                  ? aadharicongrey
                  : currentStep === "2"
                    ? bankgrey
                    : currentStep === "3"
                      ? nomineegrey
                      : sigicon
              }
              style={{
                filter:
                  currentStep === "4"
                    ? "grayscale(0.95) invert(0.1) brightness(1)"
                    : "",
              }}
            />{" "}
            Step {currentStep} of 4
          </div>
        )}
      <div className={styles.rightContainer}>
        {pathName === "/" ||
        pathName === "/confirm_otp" ||
        pathName === "/confirmemailotp" ||
        pathName === "/yourdetails" ? (
          <div className={styles.needHelpSection} style={{ marginTop: "3px" }}>
            <FormControl fullWidth>
              <div className={styles.mobilemenuicon}>
                {/* <IconButton onClick={handleClick}>
                  <MenuOutlinedIcon />
                </IconButton> */}
                <Button
                  onClick={handleClick}
                  sx={{
                    background: "black",
                    color: "white",
                    textTransform: "none",
                    padding: "10px 20px",
                    width: { xs: "100%", sm: "110%" },
                    justifyContent: "center",
                    height: "40px",
                    "&:hover": {
                      background: "black",
                    },
                  }}
                >
                  Need Help?
                </Button>
              </div>
              <div className={styles.desktopmenuicon}>
                <Button
                  onClick={handleClick}
                  sx={{
                    background: "black",
                    color: "white",
                    textTransform: "none",
                    padding: "10px 20px",
                    width: { xs: "100%", sm: "110%" },
                    justifyContent: "center",
                    height: "40px",
                    "&:hover": {
                      background: "black",
                    },
                  }}
                >
                  Need Help?
                </Button>
              </div>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  sx: {
                    "& .Mui-selected": {
                      backgroundColor: "white",
                      color: "black",
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    },
                  },
                }}
                PaperProps={{
                  sx: {
                    borderRadius: "10px",
                    marginTop: "5px",
                  },
                }}
              >
                <div
                  // onClick={(event) => {
                  //   event.stopPropagation();
                  //   console.log("+91-9900199801 clicked");
                  // }}
                  style={{
                    background: "white",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 15px",
                  }}
                >
                  <WhatsAppIcon sx={{ marginRight: "3px", fontSize: "16px" }} />
                  +91-9900199801
                </div>
                <div
                  style={{
                    background: "white",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 15px",
                  }}
                >
                  <PhoneInTalkIcon
                    sx={{ marginRight: "3px", fontSize: "16px" }}
                  />
                  080 4670 2020
                </div>
                <div
                  style={{
                    background: "white",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 15px",
                  }}
                >
                  <MailOutlineIcon
                    sx={{ marginRight: "3px", fontSize: "16px" }}
                  />
                  sales@firstock.in
                </div>
              </Menu>
            </FormControl>
          </div>
        ) : (
          ""
        )}

        {pathName !== "/" &&
          pathName !== "/confirm_otp" &&
          pathName !== "/confirmemailotp" &&
          pathName !== "/yourdetails" &&
          pathName !== "/ekyc_aadhaar" &&
          pathName !== "/ekyc_esign" &&
          pathName !== "/completed" &&
          pathName !== "/account_aggregator" &&
          pathName !== "/congratulations" && (
            <>
              <div
                className={styles.dropSection}
                style={{
                  background: "none",
                  border: "none",
                }}
                // onClick={() => {
                //   setOpenMenu(!openMenu);
                // }}
              >
                <div className={styles.needHelpSection}>
                  <FormControl fullWidth>
                    <Button
                      onClick={handleClick}
                      sx={{
                        background: "black",
                        color: "white",
                        textTransform: "none",
                        width: "100%",
                        padding: "10px 20px",
                        justifyContent: "center",
                        height: "40px",
                        "&:hover": {
                          background: "black",
                        },
                      }}
                    >
                      Need Help?
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        sx: {
                          "& .Mui-selected": {
                            backgroundColor: "white",
                            color: "black",
                            "&:hover": {
                              backgroundColor: "white",
                            },
                          },
                        },
                      }}
                      PaperProps={{
                        sx: {
                          borderRadius: "10px",
                          marginTop: "5px",
                        },
                      }}
                    >
                      <div
                        // onClick={(event) => {
                        //   event.stopPropagation();
                        //   console.log("+91-9900199801 clicked");
                        // }}
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <WhatsAppIcon
                          sx={{ marginRight: "3px", fontSize: "16px" }}
                        />
                        +91-9900199801
                      </div>
                      <div
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <PhoneInTalkIcon
                          sx={{ marginRight: "3px", fontSize: "16px" }}
                        />
                        080 4670 2020
                      </div>
                      <div
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <MailOutlineIcon
                          sx={{ marginRight: "3px", fontSize: "16px" }}
                        />
                        sales@firstock.in
                      </div>
                      <div
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <Button
                          onClick={handleLogout}
                          variant="outlined"
                          endIcon={<img src={logouticon} />}
                          sx={{
                            color: "#111827",
                            width: "100%",
                            height: "40px",
                            fontSize: "14px",
                            fontWeight: 500,
                            border:
                              "1.5px solid var(--Red-Black-Black-200, #E5E7EB)",
                            "&:hover": {
                              background: "white",
                              border:
                                "1.5px solid var(--Red-Black-Black-200, #E5E7EB)",
                            },
                          }}
                        >
                          Logout
                        </Button>
                      </div>
                    </Menu>
                  </FormControl>
                </div>
              </div>
              {openMenu && (
                <div className={styles.dropSectionMobile}>
                  <div className={styles.step}>
                    <img
                      src={
                        currentStep === "1"
                          ? aadharicongrey
                          : currentStep === "2"
                            ? bankgrey
                            : currentStep === "3"
                              ? nomineegrey
                              : sigicon
                      }
                      style={{
                        filter:
                          currentStep === "4"
                            ? "grayscale(0.95) invert(0.1) brightness(1)"
                            : "",
                      }}
                    />{" "}
                    Step {currentStep} of 4
                    <ArrowDropDownIcon
                      style={{
                        transform: openMenu ? "rotate(-180deg)" : "",
                        transition: "all 0.3s ease",
                      }}
                    />
                  </div>
                </div>
              )}
              {!openMenu && (
                <div
                  className={styles.dropSectionMobile}
                  onClick={() => {
                    setOpenMenu((prev) => !prev);
                  }}
                  ref={menuRef}
                >
                  <div className={styles.step}>
                    <img
                      src={
                        currentStep === "1"
                          ? aadharicongrey
                          : currentStep === "2"
                            ? bankgrey
                            : currentStep === "3"
                              ? nomineegrey
                              : sigicon
                      }
                      style={{
                        filter:
                          currentStep === "4"
                            ? "grayscale(0.95) invert(0.1) brightness(1)"
                            : "",
                      }}
                    />{" "}
                    Step {currentStep} of 4
                    <ArrowDropDownIcon
                      style={{
                        transform: openMenu ? "rotate(-180deg)" : "",
                        transition: "all 0.3s ease",
                      }}
                    />
                  </div>
                  {/* {openMenu ? <CloseOutlinedIcon /> : <MenuOutlinedIcon />} */}
                </div>
              )}
            </>
          )}
        {openMenu && (
          <div className={styles.backdrop}>
            <div ref={menuRef} className={styles.dropOptions}>
              {/* <div className={styles.progressSection}>
              <div className={styles.progress}>
                <LinearProgress
                  variant="determinate"
                  value={completedstages?.length * 10}
                  color="inherit"
                  sx={{
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#049981",
                      borderRadius: "5px",
                    },
                  }}
                  style={{
                    borderRadius: "5px",

                    color: "rgba(0, 0, 0, 0.40)",
                  }}
                />
              </div>

              <p className={styles.progressPercent}>
                {completedstages?.length * 10}%
              </p>
            </div> */}
              <div className={styles.stagesSection}>
                {StageNew.map((a: any, index: any) => {
                  const stageKey: any = getKeyByValue(MappingValues, a.title);
                  const isCompleted = completedstages.filter(
                    (a: any) => a == stageKey,
                  );

                  return (
                    <div
                      className={styles.stageContainer}
                      style={{ color: isCompleted?.length ? "#049981" : "" }}
                      onClick={() => {
                        if (a.title === "Identity Verification") {
                          if (panstage === "Completed") {
                            window.location.href = "/aadhaar";
                          }
                        }
                        if (a.title === "Bank Details") {
                          if (bankstage === "Completed") {
                            window.location.href = "/linkusingifsc";
                          }
                        }
                        if (a.title === "Nominee Details") {
                          if (nomineestage === "Completed") {
                            window.location.href = "/nominee";
                          }
                        }
                      }}
                    >
                      {isCompleted?.length ? a.iconGreen : a.iconGrey}
                      {a.title}{" "}
                      {/* {isCompleted?.length ? (
                      <DoneAllOutlinedIcon sx={{ fontSize: "18px" }} />
                    ) : (
                      ""
                    )} */}
                    </div>
                  );
                })}
              </div>

              <div
                className={styles.needHelpSection}
                style={{
                  borderTop: "none",
                  marginTop: "0px",
                }}
              >
                <FormControl fullWidth>
                  <Button
                    onClick={handleClickMobile}
                    sx={{
                      background: "black",
                      color: "white",
                      textTransform: "none",
                      width: "100%",
                      padding: "10px 20px",
                      justifyContent: "center",
                      height: "40px",
                      "&:hover": {
                        background: "black",
                      },
                    }}
                  >
                    Need Help?
                  </Button>
                  {openMobile && (
                    <Menu
                      anchorEl={anchorElMobile}
                      open={openMobile}
                      onClose={handleCloseMobile}
                      MenuListProps={{
                        sx: {
                          zIndex: 9999,
                          "& .Mui-selected": {
                            backgroundColor: "white",
                            color: "black",
                            "&:hover": {
                              backgroundColor: "white",
                            },
                          },
                        },
                      }}
                      PaperProps={{
                        sx: {
                          borderRadius: "10px",
                          marginTop: "5px",
                        },
                      }}
                    >
                      <div
                        // onClick={(event) => {
                        //   event.stopPropagation();
                        //   console.log("+91-9900199801 clicked");
                        // }}
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <WhatsAppIcon
                          sx={{ marginRight: "3px", fontSize: "16px" }}
                        />
                        +91-9900199801
                      </div>
                      <div
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <PhoneInTalkIcon
                          sx={{ marginRight: "3px", fontSize: "16px" }}
                        />
                        080 4670 2020
                      </div>
                      <div
                        style={{
                          background: "white",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 15px",
                        }}
                      >
                        <MailOutlineIcon
                          sx={{ marginRight: "3px", fontSize: "16px" }}
                        />
                        sales@firstock.in
                      </div>
                    </Menu>
                  )}
                </FormControl>
              </div>
              <div className={styles.logoutSection}>
                <Button
                  onClick={handleLogout}
                  variant="outlined"
                  endIcon={<img src={logouticon} />}
                  sx={{
                    color: "#111827",
                    width: "100%",
                    height: "40px",
                    fontSize: "14px",
                    fontWeight: 500,
                    border: "1.5px solid var(--Red-Black-Black-200, #E5E7EB)",
                    "&:hover": {
                      background: "white",
                      border: "1.5px solid var(--Red-Black-Black-200, #E5E7EB)",
                    },
                  }}
                >
                  Logout
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeaderComp;
